import React from 'react'
import styles from './StudentRightSideContent.module.css'
import Personal from './Personal'
import { Proporties } from './Proporties'

export default function StudentRightSideContent({ }) {
    return (
        <div className={styles.StudentRightSideContent}>
            <Personal />
            <Proporties  />
        </div>
    )
}
